import { useContext } from 'react';
import { AlertContext, AlertProviderContext } from '../contexts/AlertProvider';

function useAlert(): AlertProviderContext {
  return useContext(AlertContext);
}

export default useAlert;
